// extracted by mini-css-extract-plugin
export var svgDefs = "gg_r2";